import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import type { Release } from "@packages/commons";
import CheckboxField from "@imminently/decisively-ui/CheckboxField";
import Dialog, { useDialog, useDialogContext } from "@imminently/decisively-ui/Dialog";
import { DialogHeader } from "@/ui/dialogs/DialogHeader";
import { exportRelease } from "@/redux";
import { WORKSPACE_LAYER } from "@/ui/dialogs/layers";
import { getReleaseUiName } from "../utils";
import SwitchField from "@imminently/decisively-ui/SwitchField";

interface ExportReleaseModalProps {
  release: Release;
}

const ExportReleaseModal = ({ release }: ExportReleaseModalProps) => {
  const dispatch = useDispatch();
  const dialogContext = useDialogContext();
  const [includeScenarios, setIncludeScenarios] = useState(true);

  const handleExport = () => {
    dispatch(
      exportRelease(release.id, {
        includeScenarios,
        fallbackProjectName: typeof release.model === "string" ? release.model : undefined,
      }),
    );
    dialogContext?.close();
  };

  return (
    <Dialog.Content className="flex flex-col">
      <DialogHeader title={`Export ${getReleaseUiName(release)}`} />

      <Dialog.Body>
        <SwitchField
          value={includeScenarios}
          name="scenarios"
          label="Include Scenarios"
          onValueChange={setIncludeScenarios}
        />
      </Dialog.Body>

      <Dialog.Actions>
        <Dialog.Actions.CancelButton label="Cancel">Cancel</Dialog.Actions.CancelButton>
        <Dialog.Actions.PrimaryButton
          onClick={handleExport}
          label="Export"
        >
          Export
        </Dialog.Actions.PrimaryButton>
      </Dialog.Actions>
    </Dialog.Content>
  );
};

export const useExportReleaseModal = () => {
  const { pushDialog } = useDialog();

  return useCallback(
    (release: Release) => {
      pushDialog({
        layer: WORKSPACE_LAYER,
        options: { intent: "form" },
        component: () => <ExportReleaseModal release={release} />,
      });
    },
    [pushDialog],
  );
};
